<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>资讯管理/资讯列表</span>
			</div>
			<div>
				<el-form :inline="true" :model="searchInfo" class="demo-form-inline">
					<el-form-item label="资讯ID">
						<el-input
							class="custom_input_60"
							v-model="searchInfo.id"
							placeholder=""
						>
						</el-input>
					</el-form-item>
					<el-form-item label="作者名称">
						<el-input
							class="custom_input_60"
							v-model="searchInfo.name"
							placeholder=""
						>
						</el-input>
					</el-form-item>
					<el-form-item label="资讯信息">
						<el-input
							class="custom_input_100"
							v-model="searchInfo.title"
							placeholder=""
						>
						</el-input>
					</el-form-item>

					<el-form-item label="文章类型">
						<el-select
							class="custom_input_80"
							v-model="searchInfo.type"
							placeholder=""
						>
							<el-option label="文章" value="1"></el-option>
							<el-option label="快讯" value="2"></el-option>
							<el-option label="专栏" value="5"></el-option>
							<el-option label="活动" value="7"> </el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="状态">
						<el-select
							class="custom_input_120"
							v-model="searchInfo.status"
							placeholder=""
						>
							<el-option label="已发布" value="1"></el-option>
							<el-option label="待发布" value="2"></el-option>
							<el-option label="草稿箱" value="0"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="时间段">
						<el-date-picker
							v-model="searchInfo.dataRanger"
							type="daterange"
							size="large"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						>
						</el-date-picker>
					</el-form-item>

					<el-form-item>
						<el-button class="search-btn" type="primary" @click="searchBtn"
							>查询</el-button
						>
						<el-button class="search-btn" type="primary" @click="reset"
							>重置</el-button
						>
						<el-button
							class="search-btn"
							type="primary"
							@click="exportExcel"
							:loading="downloadLoading"
							>导出</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData" :from="from" :loading="loading"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import tablec from "./tablec.vue";
import ExportExcel from "../../../components/ExportExcel.vue";
import {
	getInformationList,
	getCategoryList,
	getLabelList,
} from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	mixins: [searchMixin],
	components: { tablec, ExportExcel },
	name: "",
	data() {
		return {
			tableData: [],
			total: 0,
			categoryList: [],
			labelList: [],
			downloadLoading: false,
			loading: false,
			searchInfo: {
				title: "",
				category_id: "",
				label_id: "",
				type: "",
				user_type: "",
				page: 1,
				size: 10,
				name: "",
				status: "1",
				id: "",
				dataRanger: "",
				source_type: "10000",
			},
			from: 0,
		};
	},
	created() {
		let _obj = JSON.parse(sessionStorage.getItem("messageListKey_m"));
		if (_obj) {
			Object.keys(this.searchInfo).forEach((key) => {
				this.searchInfo[key] = _obj[key] || this.searchInfo[key];
			});
		}
		this.getDataList();
		this.getCategoryListFun();
		this.getLabelListFun();
	},
	methods: {
		exportExcel() {
			this.downloadLoading = true;
			const headers = [
				"资讯ID",
				"资讯标题",
				"文章类型",
				"操作类型",
				"操作人",
				"作者",
				"阅读量",
				"发布时间",
				"状态",
				"链接",
			];
			const fields = [
				"id",
				"title",
				"type",
				"edit_type",
				"adminName",
				"nickname",
				"visits_num",
				"release_time",
				"status",
				"link",
			]; // 对应接口字段
			const formatDataForExcel = (data) => {
				const rows = data.map((item) =>
					fields.map((field) => {
						// 可以在此对字段值进行格式化处理，例如转换状态码为文字
						if (field === "status") {
							return item[field] === 1
								? "已发布"
								: item[field] === 2
								? "待发布"
								: "草稿箱";
						} else if (field === "type") {
							return item[field] === 1
								? "文章"
								: item[field] === 2
								? "快讯"
								: item[field] === 5
								? "专栏"
								: item[field] === 7
								? "活动"
								: "";
						} else if (field === "edit_type") {
							return item[field] === 1
								? "PR"
								: item[field] === 2
								? "人工原创"
								: item[field] === 6
								? "AI原创"
								: item[field] === 3
								? "翻译"
								: item[field] === 4
								? "转载"
								: item[field] === 5
								? "审核"
								: item[field] === 7
								? "AI转载"
								: "";
						} else if (field === "link") {
							if (item["type"] == 2) {
								return "https://me.news/news/" + item["id"];
							} else {
								return "https://me.news/contents/" + item["id"];
							}
						}
						return item[field];
					}),
				);
				return [headers, ...rows]; // 第一行是表头
			};

			const par = this.searchInfo;
			par["size"] = 10000;
			getInformationList(par)
				.then((res) => {
					console.log(res);
					this.loading = false;
					var data = res.data.data;
					// 将 JSON 数据转换为工作簿对象
					const ws = XLSX.utils.aoa_to_sheet(formatDataForExcel(data));
					const wb = XLSX.utils.book_new();
					XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

					// 生成二进制字符串
					const wbout = XLSX.write(wb, {
						bookType: "xlsx",
						bookSST: true,
						type: "array",
					});

					// 保存文件
					try {
						FileSaver.saveAs(
							new Blob([wbout], {
								type: "application/octet-stream",
							}),
							"资讯列表" + ".xlsx",
						);
					} catch (e) {
						if (typeof console !== "undefined") console.log(e, wbout);
					}

					this.downloadLoading = false;
				})
				.catch((error) => {
					console.error("导出失败:", error);
					this.downloadLoading = false;
				});
		},
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		getLabelListFun() {
			getLabelList({})
				.then((res) => {
					if (res.code == 200) {
						this.labelList = res.data.data;
					} else {
						this.labelList = [];
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		getCategoryListFun() {
			getCategoryList({})
				.then((res) => {
					if (res.code == 200) {
						this.categoryList = res.data.data;
					} else {
						this.categoryList = [];
					}
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		getDataList() {
			this.loading = true;
			this.searchInfo.source_type = "10000";
			let _data = Object.assign(this.searchInfo, {});
			sessionStorage.setItem("messageListKey_m", JSON.stringify(_data));
			const that = this;
			getInformationList(this.searchInfo)
				.then((res) => {
					this.loading = false;
					console.log(res);
					if (res.code == 200) {
						that.tableData = res.data.data;
						that.total = res.data.total;
						this.from = this.searchInfo.status == "1" ? "0" : "3";
					} else {
						that.tableData = [];
						that.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					this.$message.error(error.message);
				});
		},
		reset() {
			this.searchInfo = {
				title: "",
				category_id: "",
				label_id: "",
				type: "",
				user_type: "",
				page: 1,
				size: 10,
				name: "",
				status: "1",
				id: "",
				dataRanger: "",
				source_type: "10000",
			};
			this.getDataList();
		},
	},
};
</script>

<style scoped></style>
